import { Component, OnInit } from '@angular/core';
import { ApplicantService } from 'app/laas/applicant.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'wl-digireport',
  templateUrl: './digireport.component.html',
  styles: [],
  providers: [ApplicantService]
})
export class DigireportComponent implements OnInit {
  public id: string;
  aadhaar: any;
  pan: any;
  dl: any;
  epic: any;
  passport: any;
  nrega: any;
  tBill: any;
  eBill: any;
  lpg: any;
  emp: any;
  epf: any;
  esic: any;
  itr_1: any;
  itr_2:any;
  itr_3: any;
  form16_1: any;
  form16_2 : any;
  form16_3 : any;
  basic: any;
  residential: any;
  otherLoan: any;
  keys: any;
  shops:any;
  udhyog:any;
  fssai:any;
  iec:any;
  fda:any;
  mca:any;
  gstid:any;
  gstauth:any;
  icai:any;
  icsi:any;
  icwaifirm:any;
  icwaimem:any;
  mci:any;

  constructor(
    private applicant: ApplicantService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {

    this.id = this.route.snapshot.paramMap.get('id');
    console.log("userIId " + this.id);

    this.applicant.getEverythingReport(this.id).subscribe(details => {
      // console.log("detais " + JSON.stringify(details));
      if (details.docs) {
        const id = details.docs.id;
        if (id) {
          // this.aadhaar = id.aadhaar && id.aadhaar.ocr ? id.aadhaar.ocr : null;
          this.pan = id.pan && id.pan.ocr ? id.pan.ocr : null;
          this.dl = id.dl && id.dl.auth ? id.dl.auth : null;
          this.epic = id.epic && id.epic.auth ? id.epic.auth : null;
          this.passport = id.passport && id.passport.ocr ? id.passport.ocr : null;
          this.nrega = id.nrega && id.nrega.auth ? id.nrega.auth : null;
        }

        const address = details.docs.address;
        if (address) {
          this.tBill = address.tBill && address.tBill.auth ? address.tBill.auth : null;
          this.eBill = address.eBill && address.eBill.auth ? address.eBill.auth : null;
          this.lpg = address.lpg && address.lpg.auth ? address.lpg.auth : null;
        }

        const income = details.docs.income;

        // console.log("incom " + JSON.stringify(income.itr));
        if (income) {
          // this.keys = income.form16.input && income.form16.input[1] ? Object.keys(income.form16.input) : null;
          if(income.form16.hasOwnProperty('ocr')){
          this.form16_1 = income.form16 && income.form16.ocr[1] ? income.form16.ocr[1] : null;
          this.form16_2 = income.form16 && income.form16.ocr[2] ? income.form16.ocr[2] : null;
          this.form16_3 = income.form16 && income.form16.ocr[3] ? income.form16.ocr[3] : null;
          }
          if(income.itr.hasOwnProperty('ocr')){
            this.itr_1 = income.itr && income.itr.ocr[1] ? income.itr.ocr[1] : null;
            this.itr_2 = income.itr && income.itr.ocr[2] ? income.itr.ocr[2] : null;
            this.itr_3 = income.itr && income.itr.ocr[3] ? income.itr.ocr[3] : null;
          }


          // console.log
        }
        const employment = details.docs.employment
        if (employment) {
          this.emp = employment.work && employment.work.input;
          this.esic = employment.esic && employment.esic.auth ? employment.esic.auth : null;
          this.epf = employment.epf && employment.epf.auth ? employment.epf.auth : null;
        }

        if (details.docs.personalDetails) {
          let personal = details.docs.personalDetails;
          this.basic = personal.basicDetails && personal.basicDetails.input;
          this.residential = personal.residentDetails && personal.residentDetails.input;
          this.otherLoan = personal.loanDetails && personal.loanDetails.input;
        }

        const business = details.docs.business;
        // console.log("business.icsi.auth " + business.icsi.auth)
        // console.log("business.icsi.auth.length " + business.icsi.auth.length)
        if(business){
          this.shops = business.shopsEstablishment && business.shopsEstablishment.auth ? business.shopsEstablishment.auth : null;
          this.udhyog = business.udhyogAdhaar && business.udhyogAdhaar.auth ? business.udhyogAdhaar.auth : null;
          this.fssai = business.fssai && business.fssai.auth ? business.fssai.auth : null;
          this.iec = business.iec && business.iec.auth && typeof (business.iec.auth) != "string" ? business.iec.auth : null;
          this.fda = business.fda && business.fda.auth ? business.fda.auth : null;
          this.mca = business.mca && business.mca.auth ? business.mca.auth : null;
          this.gstid = business.gst && business.gst.authIdentity ? business.gst.authIdentity : null;
          this.gstauth = business.gst && business.gst.auth ? business.gst.auth : null;
          this.icai = business.icai && business.icai.auth ? business.icai.auth : null;
          this.icsi = business.icsi && business.icsi.auth && business.icsi.auth.length > 0? business.icsi.auth[0] : null;
          this.icwaifirm = business.icwai && business.icwai.authFirm ? business.icwai.authFirm : null;
          this.icwaimem = business.icwai && business.icwai.authMem ? business.icwai.authMem : null;
          this.mci = business.mci && business.mci.auth && business.mci.auth.result ? business.mci.auth.result : null;

        }
      }
    })
  }

}
